import { createShareMessage, sendMessageToHost } from "./events";
import { isMobileNative, throttle } from "./helpers";
import { getFullUrl } from "./url";

/**
 * Opens a share modal (either natively or on web)
 */
export const sharePage = throttle(
  (path: string, target: EventTarget | null, showShareModal?: () => void) => {
    const url = getFullUrl(path);
    if (isMobileNative()) {
      sendMessageToHost(createShareMessage(url, target));
    } else {
      showShareModal?.();
    }
  },
  1_000,
);
